import LegacyLayout from './LegacyLayout';

export { LegacyLayout };
